export class BulkCreateQuestionBankItem {
  className: string;
  subjectName: string;
  chapterName: string;
  topicName?: string;
  marks: number;
  abilityName?: string;
  abilityTypeName?: string;
  difficultyName?: string;
  questionTypeName?: string;
  questionEn?: string;
  questionHi?: string;
  hasStimulus?: string;
  estimatedTime?: number;
  competencyCode?: string;
  answerKey?: string;
  preparedBy?: string;
  mobileNo?: string;
  remarks?: string;
  questionPaperPrintedLanguage?: string;
}

export class BulkCreateQuestionBankReqModel {
  questions: BulkCreateQuestionBankItem[];
  userName: string;
}
